// Public module collection. Renderer modules register themselves here as they
// land; shared Chart.js plugins will be registered here once one is shared by
// more than one module. Modules: histogram (#2), shift-plot (#14),
// delta-delta (#25), results-over-time (#27), outlier-explorer (#24),
// ae-timelines (#26), hep-explorer (#43), ae-explorer (#60), qt-explorer (#68),
// hep-waterfall (#93), participant-profile (#98), nep-explorer (#120),
// time-to-event (#128), patient-journey-explorer (#142). The portfolio manifest
// (#138) rides along as `portfolio`: the standard domain set and what each
// module reads from it, for the hosts that put several charts on one page. The
// kit (#154) rides along as `kit`: the shared parts every chart is built from,
// re-exported unchanged for a second chart library on the same page.
import histogram from './histogram.js';
import shiftPlot from './shift-plot.js';
import deltaDelta from './delta-delta.js';
import resultsOverTime from './results-over-time.js';
import outlierExplorer from './outlier-explorer.js';
import aeTimelines from './ae-timelines.js';
import hepExplorer from './hep-explorer.js';
import aeExplorer from './ae-explorer.js';
import qtExplorer from './qt-explorer.js';
import hepWaterfall from './hep-waterfall.js';
import participantProfile from './participant-profile.js';
import nepExplorer from './nep-explorer.js';
import timeToEvent from './time-to-event.js';
import patientJourneyExplorer from './patient-journey-explorer.js';
import portfolio from './data/portfolio.json';
import { kit } from './kit.js';

export {
  histogram,
  shiftPlot,
  deltaDelta,
  resultsOverTime,
  outlierExplorer,
  aeTimelines,
  hepExplorer,
  aeExplorer,
  qtExplorer,
  hepWaterfall,
  participantProfile,
  nepExplorer,
  timeToEvent,
  patientJourneyExplorer,
  portfolio,
  kit
};
export default {
  histogram,
  shiftPlot,
  deltaDelta,
  resultsOverTime,
  outlierExplorer,
  aeTimelines,
  hepExplorer,
  aeExplorer,
  qtExplorer,
  hepWaterfall,
  participantProfile,
  nepExplorer,
  timeToEvent,
  patientJourneyExplorer,
  portfolio,
  kit
};
